import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BirthdateModalComponent } from '@components/birthdate-modal';
import { FooterComponent } from '@components/footer';
import { MastheadComponent } from '@components/masthead';
import { SnackBarComponent } from '@components/snack-bar';
import { AuthService } from '@features/auth';

@Component({
  selector: 'app-root',
  providers: [],
  imports: [
    RouterOutlet,
    MastheadComponent,
    FooterComponent,
    SnackBarComponent,
    BirthdateModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent {
  #auth = inject(AuthService);

  protected requiresBirthdateEntry = this.#auth.requiresBirthdateEntry;
}
